// Arabic translations
const translations = {
  common: {
    smartCity: 'المدينة الذكية',
    dashboard: 'لوحة المعلومات',
    map: 'خريطة',
    analytics: 'تحليلات',
    settings: 'الإعدادات',
    profile: 'الملف الشخصي',
    profileSettings: 'إعدادات الملف الشخصي',
    notifications: 'الإشعارات',
    helpSupport: 'المساعدة والدعم',
    systemStatus: 'حالة النظام',
    search: 'بحث',
    signOut: 'تسجيل الخروج',
    systemRunningNormally: 'النظام يعمل بشكل طبيعي',
    viewAllNotifications: 'عرض كل الإشعارات',
    toggleColorMode: 'تبديل وضع الألوان',
    administrator: 'مدير النظام',
    type: 'النوع',
    sensors: 'أجهزة الاستشعار',
    coordinates: 'الإحداثيات',
    view: 'عرض',
    details: 'التفاصيل',
    active: 'نشط',
    inactive: 'غير نشط',
    maintenance: 'صيانة',
    all: 'الكل',
    error: 'خطأ',
    errorLoadingData: 'خطأ في تحميل البيانات',
    refresh: 'تحديث',
    user: 'مستخدم',
    moderator: 'مشرف',
    manager: 'مدير',
    operator: 'مشغل',
    viewer: 'مشاهد',
    guest: 'ضيف',
    success: 'نجاح',
    required: 'هذا الحقل مطلوب',
    invalidValue: 'قيمة غير صالحة',
    invalidRange: 'القيمة خارج النطاق الصالح',
    operational: 'يعمل',
    notOperational: 'لا يعمل',
    timestamp: 'الطابع الزمني',
    deviceId: 'معرف الجهاز',
    lastUpdated: 'آخر تحديث',
    exportData: 'تصدير البيانات',
    saveChanges: 'حفظ التغييرات',
    updateFailed: 'فشل التحديث',
    errorLoadingLocation: 'خطأ في تحميل بيانات الموقع',
    backToLocations: 'العودة إلى المواقع',
    description: 'الوصف',
    multiSelect: 'تحديد متعدد',
    clearSelection: 'مسح التحديد',
    delete: 'حذف',
  },

  dashboard: {
    trafficOverview: 'نظرة عامة على حركة المرور',
    recentEvents: 'الأحداث الأخيرة',
    sensorStatus: 'حالة أجهزة الاستشعار',
    systemHealth: 'صحة النظام',
    trafficVolume: 'حجم حركة المرور',
    incidents: 'الحوادث',
    events: 'الأحداث',
    sensors: 'أجهزة الاستشعار',
    reports: 'التقارير',
    calendar: 'التقويم',
    signalStatus: 'حالة الإشارة',
    averageTravelTime: 'متوسط وقت السفر',
    viewDetails: 'عرض التفاصيل',
    viewAll: 'عرض الكل',
    online: 'متصل',
    offline: 'غير متصل',
    uptime: 'وقت التشغيل',
    responseTime: 'وقت الاستجابة',
    dataPoints: 'نقاط البيانات',
    lastUpdate: 'آخر تحديث',

    // Added new location page translations
    addNew: 'إضافة جديد',
    searchLocations: 'البحث عن المواقع...',
    filterByType: 'تصفية حسب النوع',
    filterByStatus: 'تصفية حسب الحالة',
    grid: 'شبكة',
    list: 'قائمة',
    noLocationsFound: 'لم يتم العثور على مواقع',
    tryDifferentSearch: 'جرب بحثًا مختلفًا أو مرشحًا آخر',
    locationsDescription: 'إدارة ومراقبة بيانات الموقع',

    // Add location modal translations
    addNewLocation: 'إضافة موقع جديد',
    locationNamePlaceholder: 'أدخل اسم الموقع',
    locationAddressPlaceholder: 'أدخل العنوان',
    locationTypePlaceholder: 'مثال: تقاطع، طريق سريع، إلخ',
    locationAddedSuccess: 'تمت إضافة الموقع بنجاح',
    locationDeletedSuccess: 'تم حذف الموقع بنجاح',
    locationDeleteFailed: 'فشل في حذف الموقع',
    deleteLocationsTitle: 'حذف المواقع',
    deleteLocationsConfirm: 'هل أنت متأكد أنك تريد حذف {{count}} موقع/مواقع؟',
    deleteLocationsWarning:
      'لا يمكن التراجع عن هذا الإجراء. سيتم قطع اتصال جميع أجهزة الاستشعار المتصلة بهذه المواقع.',
    bulkDeleteSuccess: 'تم حذف {{count}} موقع/مواقع بنجاح',
    bulkDeletePartialSuccess: 'نجاح جزئي: تم حذف {{success}} موقع/مواقع، فشل في {{failed}}',
    bulkDeleteFailed: 'فشل في حذف المواقع',
    locationUpdatedSuccess: 'تم تحديث الموقع بنجاح',
    editLocationDesc: 'تحرير تفاصيل الموقع والإحداثيات',
    locationDescriptionPlaceholder: 'أدخل وصف الموقع (اختياري)',
    locationsMap: 'خريطة المواقع',
  },

  // إضافة إعدادات النظام والتكوين
  settings: {
    dashboard: 'لوحة الإعدادات',
    system: 'إعدادات النظام',
    user: 'إعدادات المستخدم',
    organization: 'إعدادات المنظمة',
    security: 'إعدادات الأمان',
    notifications: 'إعدادات الإشعارات',
    integrations: 'إعدادات التكامل',
    maintenance: 'إعدادات الصيانة',

    // إدارة المستخدمين
    'User Management': 'إدارة المستخدمين',
    'User Profiles': 'ملفات المستخدمين',
    'Role Management': 'إدارة الأدوار',
    'Permission Settings': 'إعدادات الصلاحيات',
    'Access Control': 'التحكم في الوصول',
    'User Groups': 'مجموعات المستخدمين',
    Authentication: 'المصادقة',
    'Session Management': 'إدارة الجلسات',

    // تكوين النظام
    'System Configuration': 'تكوين النظام',
    'General Settings': 'الإعدادات العامة',
    'Performance Settings': 'إعدادات الأداء',
    'Database Settings': 'إعدادات قاعدة البيانات',
    'Cache Settings': 'إعدادات التخزين المؤقت',
    'Logging Settings': 'إعدادات السجلات',
    'Backup Settings': 'إعدادات النسخ الاحتياطي',
    'Import/Export': 'الاستيراد/التصدير',

    // إعدادات API والتكامل
    'API Configuration': 'تكوين API',
    'Rate Limiting': 'تحديد المعدل',
    'Webhook Settings': 'إعدادات Webhook',
    'External APIs': 'واجهات برمجة التطبيقات الخارجية',
    'Data Sync': 'مزامنة البيانات',
    'Protocol Settings': 'إعدادات البروتوكول',
    'Connection Testing': 'اختبار الاتصال',
    'Integration Status': 'حالة التكامل',

    // إدارة الإشعارات
    'Notification Types': 'أنواع الإشعارات',
    'Email Settings': 'إعدادات البريد الإلكتروني',
    'SMS Settings': 'إعدادات الرسائل النصية',
    'Push Notifications': 'الإشعارات الفورية',
    'Alert Preferences': 'تفضيلات التنبيهات',
    'Delivery Methods': 'طرق التسليم',
    'Escalation Rules': 'قواعد التصعيد',
    'Notification Templates': 'قوالب الإشعارات',

    // تكوين الأمان
    'Password Policy': 'سياسة كلمات المرور',
    'Two-Factor Authentication': 'المصادقة الثنائية',
    'IP Restrictions': 'قيود عنوان IP',
    'SSL/TLS Settings': 'إعدادات SSL/TLS',
    'Encryption Settings': 'إعدادات التشفير',
    'Audit Logging': 'سجلات المراجعة',
    'Compliance Settings': 'إعدادات الامتثال',
    'Security Monitoring': 'مراقبة الأمان',

    // إدارة البيانات
    'Data Retention': 'الاحتفاظ بالبيانات',
    'Data Archiving': 'أرشفة البيانات',
    'Data Purging': 'تطهير البيانات',
    'Data Quality': 'جودة البيانات',
    'Data Sources': 'مصادر البيانات',
    'Data Validation': 'التحقق من البيانات',
    'Data Migration': 'ترحيل البيانات',
    'Data Backup': 'نسخ احتياطي للبيانات',

    // إعدادات التطبيق
    'Theme Settings': 'إعدادات الموضوع',
    'Language Settings': 'إعدادات اللغة',
    'Timezone Settings': 'إعدادات المنطقة الزمنية',
    'Display Settings': 'إعدادات العرض',
    'Layout Settings': 'إعدادات التخطيط',
    'Dashboard Preferences': 'تفضيلات لوحة المعلومات',
    'Widget Configuration': 'تكوين الأدوات',
    'Chart Settings': 'إعدادات المخططات',

    // مراقبة النظام
    'Health Monitoring': 'مراقبة الصحة',
    'Performance Monitoring': 'مراقبة الأداء',
    'Resource Usage': 'استخدام الموارد',
    'System Alerts': 'تنبيهات النظام',
    'Error Tracking': 'تتبع الأخطاء',
    'Diagnostic Tools': 'أدوات التشخيص',
    'System Status': 'حالة النظام',
    'Maintenance Windows': 'نوافذ الصيانة',
  },

  // إضافة واجهة المستخدم والمكونات
  ui: {
    navigation: 'التنقل',
    menu: 'القائمة',
    toolbar: 'شريط الأدوات',
    sidebar: 'الشريط الجانبي',
    footer: 'التذييل',
    header: 'الرأس',
    breadcrumb: 'مسار التنقل',
    pagination: 'الترقيم',

    // عناصر النموذج
    'Form Elements': 'عناصر النموذج',
    'Input Fields': 'حقول الإدخال',
    'Select Boxes': 'مربعات الاختيار',
    'Check Boxes': 'مربعات الاختيار',
    'Radio Buttons': 'أزرار الراديو',
    'Text Areas': 'مناطق النص',
    'File Uploads': 'رفع الملفات',
    'Date Pickers': 'منتقيات التاريخ',
    'Time Pickers': 'منتقيات الوقت',

    // الأزرار والإجراءات
    'Primary Button': 'الزر الأساسي',
    'Secondary Button': 'الزر الثانوي',
    'Submit Button': 'زر الإرسال',
    'Cancel Button': 'زر الإلغاء',
    'Reset Button': 'زر إعادة التعيين',
    'Edit Button': 'زر التحرير',
    'Delete Button': 'زر الحذف',
    'Save Button': 'زر الحفظ',
    'Apply Button': 'زر التطبيق',
    'Close Button': 'زر الإغلاق',
    'Back Button': 'زر الرجوع',
    'Next Button': 'زر التالي',
    'Previous Button': 'زر السابق',
    'Refresh Button': 'زر التحديث',
    'Search Button': 'زر البحث',
    'Clear Button': 'زر المسح',
    'Export Button': 'زر التصدير',
    'Import Button': 'زر الاستيراد',
    'Download Button': 'زر التحميل',
    'Upload Button': 'زر الرفع',

    // النوافذ المنبثقة والحوارات
    'Modal Dialog': 'حوار منبثق',
    'Confirmation Dialog': 'حوار التأكيد',
    'Alert Dialog': 'حوار التنبيه',
    'Info Dialog': 'حوار المعلومات',
    'Warning Dialog': 'حوار التحذير',
    'Error Dialog': 'حوار الخطأ',
    'Success Dialog': 'حوار النجاح',
    'Progress Dialog': 'حوار التقدم',

    // عرض البيانات
    'Data Table': 'جدول البيانات',
    'Data Grid': 'شبكة البيانات',
    'List View': 'عرض القائمة',
    'Card View': 'عرض البطاقات',
    'Tree View': 'عرض الشجرة',
    'Chart View': 'عرض المخططات',
    'Map View': 'عرض الخريطة',
    'Detail View': 'العرض التفصيلي',

    // التحميل والحالة
    'Loading Spinner': 'مؤشر التحميل',
    'Progress Bar': 'شريط التقدم',
    'Status Indicator': 'مؤشر الحالة',
    Badge: 'شارة',
    Label: 'تسمية',
    Tag: 'علامة',
    Chip: 'شريحة',
    Tooltip: 'تلميح',

    // التخطيط والتباعد
    'Grid Layout': 'تخطيط الشبكة',
    'Flex Layout': 'التخطيط المرن',
    'Card Layout': 'تخطيط البطاقات',
    'Panel Layout': 'تخطيط اللوحات',
    'Tab Layout': 'تخطيط علامات التبويب',
    'Accordion Layout': 'تخطيط الأكورديون',
    'Sidebar Layout': 'تخطيط الشريط الجانبي',
    'Split Layout': 'التخطيط المنقسم',
  },

  analytics: {
    dashboard: 'لوحة التحليلات',
    overview: 'نظرة عامة على التحليلات',
    insights: 'رؤى حركة المرور',
    patterns: 'أنماط حركة المرور',
    predictions: 'تنبؤات حركة المرور',
    realTimeAnalytics: 'التحليلات في الوقت الفعلي',
    historicalAnalytics: 'التحليلات التاريخية',
    comparativeAnalysis: 'التحليل المقارن',

    // ميزات التحليلات المتقدمة
    'Advanced Analytics': 'التحليلات المتقدمة',
    'Machine Learning Insights': 'رؤى التعلم الآلي',
    'Predictive Models': 'النماذج التنبؤية',
    'Anomaly Detection': 'كشف الشذوذ',
    'Trend Analysis': 'تحليل الاتجاهات',
    'Statistical Analysis': 'التحليل الإحصائي',
    'Performance Metrics': 'مقاييس الأداء',
    'Data Visualization': 'تصور البيانات',
  },

  reports: {
    dashboard: 'لوحة التقارير',
    generate: 'إنشاء تقرير',
    overview: 'نظرة عامة على التقارير',
    details: 'تفاصيل التقرير',
    search: 'البحث في التقارير',
    loading: 'جاري تحميل التقارير...',
    error: 'خطأ في تحميل التقارير',
    notFound: 'التقرير غير موجود',
    reportNotFound: 'التقرير بمعرف {{id}} غير موجود',

    // إنشاء التقارير
    'Report Generator': 'مولد التقارير',
    'Select Report Type': 'اختر نوع التقرير',
    'Traffic Analysis': 'تحليل حركة المرور',
    'Incident Summary': 'ملخص الحوادث',
    'Sensor Performance': 'أداء أجهزة الاستشعار',
    'System Health': 'صحة النظام',
    'Custom Query': 'استعلام مخصص',
    'Multi-metric Dashboard': 'لوحة متعددة المقاييس',
  },

  map: {
    trafficSensors: 'مستشعرات المرور',
    nearbyEvents: 'الأحداث القريبة',
    fullScreen: 'شاشة كاملة',
    noEventsInArea: 'لا توجد أحداث في هذه المنطقة',
    sensorDetails: 'تفاصيل المستشعر',
    status: 'الحالة',
    location: 'الموقع',
    lastReading: 'آخر قراءة',
    trafficFlow: 'تدفق حركة المرور',
    averageSpeed: 'متوسط السرعة',
  },

  // حالات فارغة - رسائل إعلامية مع رسوم توضيحية
  emptyStates: {
    // أجهزة الاستشعار
    noSensors: {
      title: 'لم يتم العثور على أجهزة استشعار',
      description: 'ابدأ بإضافة أول جهاز استشعار لمراقبة حركة المرور وجمع البيانات.',
      primaryAction: 'إضافة جهاز استشعار',
      secondaryAction: 'معرفة المزيد',
    },
    noSensorsFiltered: {
      title: 'لا توجد أجهزة استشعار مطابقة',
      description:
        'لا توجد أجهزة استشعار تطابق معايير التصفية الحالية. حاول تعديل الفلاتر أو شروط البحث.',
      primaryAction: 'مسح الفلاتر',
    },

    // المواقع
    noLocations: {
      title: 'لم يتم العثور على مواقع',
      description: 'أضف مواقع لتنظيم أجهزة الاستشعار ومراقبة حركة المرور في مناطق محددة.',
      primaryAction: 'إضافة موقع',
      secondaryAction: 'استيراد المواقع',
    },
    noLocationsFiltered: {
      title: 'لا توجد مواقع مطابقة',
      description: 'لا توجد مواقع تطابق بحثك. جرب مصطلح بحث مختلف أو تصفح جميع المواقع.',
      primaryAction: 'مسح البحث',
    },

    // الأحداث
    noEvents: {
      title: 'لم يتم العثور على أحداث',
      description:
        'ستظهر أحداث حركة المرور هنا عندما تبدأ أجهزة الاستشعار في اكتشاف النشاط. تحقق من أن أجهزة الاستشعار متصلة ومهيأة بشكل صحيح.',
      primaryAction: 'فحص أجهزة الاستشعار',
      secondaryAction: 'تحديث',
    },
    noEventsFiltered: {
      title: 'لا توجد أحداث مطابقة',
      description:
        'لا توجد أحداث تطابق الفلاتر الحالية. حاول تعديل نطاق التاريخ أو معايير التصفية أو تحقق من اتصال أجهزة الاستشعار.',
      descriptionWithQuery:
        'لا توجد أحداث تطابق "{{query}}". جرب مصطلحات بحث مختلفة أو عدّل نطاق التاريخ أو تحقق من معايير التصفية.',
      descriptionWithEventId: 'لم يتم العثور على حدث بالمعرف "{{query}}". تحقق من صحة معرف الحدث.',
      primaryAction: 'مسح الفلاتر',
      secondaryAction: 'تحديث',
    },

    // المخالفات
    noViolations: {
      title: 'لم يتم العثور على مخالفات',
      description:
        'لا توجد مخالفات تطابق الفلاتر الحالية. حاول تعديل نطاق التاريخ أو نوع المخالفة.',
      primaryAction: 'تعديل الفلاتر',
      secondaryAction: 'تحديث',
    },

    // مخالفات حزام الأمان
    noSeatbeltViolations: {
      title: 'لا توجد مخالفات حزام أمان',
      description:
        'ستظهر مخالفات حزام الأمان هنا عندما تبدأ أجهزة الاستشعار في اكتشافها. تحقق من أن أجهزة الاستشعار متصلة ومهيأة لاكتشاف مخالفات حزام الأمان.',
      primaryAction: 'فحص أجهزة الاستشعار',
      secondaryAction: 'تحديث',
    },
    noSeatbeltViolationsFiltered: {
      title: 'لا توجد مخالفات مطابقة',
      description:
        'لا توجد مخالفات حزام أمان تطابق الفلاتر الحالية. حاول تعديل نطاق التاريخ أو معايير التصفية أو توسيع معايير البحث.',
      descriptionWithQuery:
        'لا توجد مخالفات حزام أمان تطابق "{{query}}". جرب مصطلحات بحث مختلفة أو عدّل نطاق التاريخ أو تحقق من معايير التصفية.',
      descriptionWithEventId:
        'لم يتم العثور على مخالفة حزام أمان بالمعرف "{{query}}". تحقق من صحة معرف الحدث.',
      primaryAction: 'مسح الفلاتر',
      secondaryAction: 'تحديث',
    },

    // التقارير
    noReports: {
      title: 'لا توجد تقارير بعد',
      description:
        'أنشئ تقارير مخصصة لتحليل أنماط حركة المرور وبيانات أجهزة الاستشعار والمخالفات عبر الزمن.',
      primaryAction: 'إنشاء تقرير',
      secondaryAction: 'عرض القوالب',
    },

    // الإشعارات
    noNotifications: {
      title: 'لا توجد إشعارات',
      description: 'أنت على اطلاع! ستظهر الإشعارات الجديدة هنا عند وجود نشاط.',
      primaryAction: 'إعدادات الإشعارات',
    },
    allNotificationsRead: {
      title: 'تم قراءة الكل!',
      description: 'ليس لديك إشعارات غير مقروءة.',
      primaryAction: 'عرض الكل',
    },

    // نتائج البحث
    noSearchResults: {
      title: 'لم يتم العثور على نتائج',
      description: 'لم يتم العثور على نتائج. جرب كلمات مفتاحية مختلفة أو وسّع بحثك.',
      descriptionWithQuery:
        'لم يتم العثور على نتائج لـ "{{query}}". جرب كلمات مفتاحية مختلفة أو تحقق من الإملاء.',
      primaryAction: 'مسح البحث',
      secondaryAction: 'تعديل الفلاتر',
      tipsTitle: 'نصائح البحث',
      tips: {
        checkSpelling: 'تحقق من الإملاء وحاول مرة أخرى',
        useKeywords: 'استخدم كلمات مفتاحية أكثر عمومية',
        removeFilters: 'أزل بعض الفلاتر لتوسيع البحث',
        tryDifferentTerms: 'جرب مصطلحات بحث مختلفة',
      },
    },

    // الأرشيف
    noArchive: {
      title: 'لا توجد أحداث مؤرشفة',
      description:
        'تتم أرشفة الأحداث تلقائياً وفقاً لسياسة الاحتفاظ. يتم الحفاظ على الأحداث المؤرشفة للامتثال والتحليل التاريخي مع تحسين قاعدة البيانات النشطة.',
      primaryAction: 'تهيئة سياسة الاحتفاظ',
      secondaryAction: 'معرفة المزيد',
    },
    noArchiveFiltered: {
      title: 'لا توجد أحداث مؤرشفة مطابقة',
      description:
        'لا توجد أحداث مؤرشفة تطابق الفلاتر الحالية. حاول تعديل نطاق التاريخ أو نوع الحدث أو مستوى الأهمية.',
      descriptionWithQuery:
        'لا توجد أحداث مؤرشفة تطابق "{{query}}". جرب مصطلحات بحث مختلفة أو عدّل معايير التصفية.',
      primaryAction: 'مسح الفلاتر',
      secondaryAction: 'تحديث',
    },

    // لا توجد بيانات عامة
    noData: {
      title: 'لا تتوفر بيانات',
      description: 'لا توجد بيانات للعرض في الوقت الحالي. تحقق لاحقاً أو حاول التحديث.',
      primaryAction: 'تحديث',
    },
  },
};

export default translations;
